import { isNumeric } from '../isNumeric/isNumeric';
/**
 * Get percent value from absolute number. Returns percent value.
 *
 * @param {number} total - Absolute value.
 * @param {number} target - Value that will be used to calculate percent.
 * @param {GetPercentOptions=} options - Options.
 *
 * @example
 * // Returns "53", because 530 of 1000 is 53%.
 * getPercentFromValue(530, 1000);
 */
export function getPercent(target, total, options = {}) {
    if (isNumeric(total) && isNumeric(target)) {
        try {
            const { toRound = true } = options;
            const result = (target * 100) / total;
            if (toRound) {
                return Math.round(result);
            }
            return result;
        }
        catch (e) {
            // do nothing
        }
    }
    throw new Error('Invalid arguments');
}
/**
 * Get value from absolute number by percent. Returns absolute value.
 *
 * @param {number} value - Absolute value.
 * @param {number} percent - Percent that will be taken from absolute value.
 *
 * @example
 * // Returns "530", because 53% of 1000 is 530.
 * getPercentFromValue(1000, 53);
 */
export function getPercentFromValue(value, percent) {
    if (isNumeric(percent) && isNumeric(value)) {
        try {
            return (percent / 100) * value;
        }
        catch (e) {
            // do nothing
        }
    }
    throw new Error('Invalid arguments');
}
